"use client";
import { Col, DatePicker, Form, Row, Select, Typography } from "antd";

import { BOM } from "../../../services/definedMethod";
import { labelConfig, staticConfig } from "../serviceProvider.config";
const { Text, Title } = Typography;

const OthersForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    disabledAfterCurrentDate,
    disableDaysBeforeToday,
    isLoading,
    formData,
    walletProduct,
    openCasa,
    clientClassificationData,
    staffData,
    isCreateScreen,
  } = props;
  console.log(openCasa, "openCasaopenCasaopenCasa");

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Other Information
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          {/* {!(legalOption === 2) && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.isStaff} name="isStaff">
                <Select
                  style={{ height: "44px" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.isStaff,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
          )} */}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.relationshipManager} name="staffId">
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.relationshipManager,
                  "select"
                )}
                options={staffData}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.customerClassification}
              name="clientClassificationId"
            >
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.customerClassification,
                  "select"
                )}
                options={clientClassificationData}
                showSearch
              />
            </Form.Item>
          </Col>
          {isCreateScreen && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.assignDefaultProduct}
                  name="openCasa"
                >
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.assignDefaultProduct,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                  />
                </Form.Item>
              </Col>
              {openCasa && (
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.walletProduct}
                    name="savingsProductId"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.walletProduct),
                      },
                    ]}
                  >
                    <Select
                      style={{ height: "44px" }}
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.walletProduct,
                        "select"
                      )}
                      options={walletProduct}
                    />
                  </Form.Item>
                </Col>
              )}
            </>
          )}
          {/* <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.submittedOn}
              name="submittedOnDate"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.submittedOn),
                },
              ]}
            >
              <DatePicker
                disabledDate={disabledAfterCurrentDate}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.submittedDate,
                  "select"
                )}
                style={{ width: "100%", height: "44px" }}
              />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default OthersForm;
